module.exports = __webpack_public_path__ + "img/IR.c023dce0.svg";